<template>
  <div class="search-result-detail">
    <div class="item" @click="setAlert">
      <svg
        width="24"
        height="21"
        viewBox="0 0 24 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.847 0.399994C11.1556 -0.133331 11.9252 -0.133331 12.2338 0.399994L22.972 19C23.2806 19.5333 22.8959 20.2 22.2787 20.2H0.802113C0.184926 20.2 -0.19984 19.5333 0.108754 19L10.847 0.399994ZM9.92516 14.2769H13.1556V17.5077H9.92516V14.2769ZM13.6947 6.73843H9.3861L9.92516 13.2H13.1556L13.6947 6.73843Z"
          fill="#858585"
        />
      </svg>
      <p>Set Alert</p>
    </div>
    <div class="item" v-if="userCan('set-tag')" @click="setTag">
      <svg 
        width="24"
        height="21"
        viewBox="0 0 24 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <circle r="8" cx="16" cy="12" fill="#858585" />
        <circle r="8" cx="12" cy="8" fill="#858585" />
      </svg>
      <p>Set Tag</p>
    </div>
    <!-- <div class="item">
      <svg width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.41667 19.2L10.5 24L14.5833 19.2H18.6667C19.9535 19.2 21 18.1236 21 16.8V2.4C21 1.0764 19.9535 0 18.6667 0H2.33333C1.0465 0 0 1.0764 0 2.4V16.8C0 18.1236 1.0465 19.2 2.33333 19.2H6.41667ZM4.66667 6H16.3333V8.4H4.66667V6ZM4.66667 10.8H12.8333V13.2H4.66667V10.8Z" fill="#858585"/>
      </svg>
      <p>Provide Feedback</p>
    </div>
    <div class="item">
      <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.99805 13.9974C6.99805 12.1409 7.73555 10.3604 9.0483 9.04769C10.3611 7.73493 12.1415 6.99744 13.998 6.99744C13.998 8.85395 13.2605 10.6344 11.9478 11.9472C10.635 13.2599 8.85456 13.9974 6.99805 13.9974Z" fill="#858585"/>
        <path d="M13.7074 4.99744C11.4204 5.07002 9.24693 6.01097 7.62895 7.62895C6.01097 9.24693 5.07002 11.4204 4.99744 13.7074C3.83615 13.3607 2.78477 12.7184 1.94619 11.8435C1.10762 10.9685 0.510591 9.89074 0.213532 8.71576C-0.0835274 7.54079 -0.0704369 6.30882 0.251522 5.14042C0.573481 3.97202 1.19328 2.90723 2.05025 2.05025C2.90723 1.19328 3.97202 0.573481 5.14042 0.251522C6.30882 -0.0704369 7.54079 -0.0835274 8.71576 0.213532C9.89074 0.510591 10.9685 1.10762 11.8435 1.94619C12.7184 2.78477 13.3607 3.83615 13.7074 4.99744Z" fill="#858585"/>
        <path d="M6.99805 13.9974C6.99805 12.1409 7.73555 10.3604 9.0483 9.04769C10.3611 7.73493 12.1415 6.99744 13.998 6.99744C13.998 8.85395 13.2605 10.6344 11.9478 11.9472C10.635 13.2599 8.85456 13.9974 6.99805 13.9974Z" fill="#858585"/>
        <path d="M20.9971 13.9974C20.9986 15.6799 20.394 17.3066 19.294 18.5798C18.1941 19.8529 16.6724 20.6873 15.0076 20.9302C13.3427 21.173 11.6461 20.8081 10.2283 19.9023C8.81047 18.9964 7.76637 17.6102 7.28711 15.9974C9.57412 15.9249 11.7476 14.9839 13.3656 13.3659C14.9836 11.748 15.9245 9.57446 15.9971 7.28745C17.442 7.71824 18.7092 8.60405 19.6101 9.81307C20.511 11.0221 20.9975 12.4897 20.9971 13.9974Z" fill="#858585"/>
      </svg>
      <p>Find Similar</p>
    </div>
    <div class="item">
      <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.6667 21C19.2855 21 19.879 20.7542 20.3166 20.3166C20.7542 19.879 21 19.2855 21 18.6667V2.33333C21 1.71449 20.7542 1.121 20.3166 0.683417C19.879 0.245833 19.2855 0 18.6667 0H2.33333C1.71449 0 1.121 0.245833 0.683417 0.683417C0.245833 1.121 0 1.71449 0 2.33333V18.6667C0 19.2855 0.245833 19.879 0.683417 20.3166C1.121 20.7542 1.71449 21 2.33333 21H18.6667ZM9.33333 10.5V4.66667H11.6667V10.5H16.3333L10.5 16.3333L4.66667 10.5H9.33333Z" fill="#858585"/>
      </svg>
      <p @click="saveSearch">Save Search</p>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: "search-result-detail",
  props: ["searchData"],
  computed: {
    ...mapGetters(['userCan'])
  },
  methods: {
    saveSearch(e) {
      this.$emit("click", e.target);
    },

    setAlert() {
      this.$emit("setAlert", this.searchData);
      document.querySelector(".search-result-detail").style.display = "none";
    },

    setTag() {
      this.$emit("setTag", this.searchData);
      document.querySelector(".search-result-detail").style.display = "none";
    },
  },
};
</script>

<style lang="scss">
.search-result-detail {
  position: absolute;
  // top: 0;
  // right: 0;
  display: none;
  background: #fff;
  border: 1px solid #cdcdcd;
  box-shadow: 0px 8px 20px rgba(51, 51, 51, 0.08);
  border-radius: 15px;
  // padding: 35px 45px;
  padding: 15px 25px;

  .item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    cursor: pointer;

    &:hover {
      p {
        color: #fcaf05;
      }

      svg path {
        fill: #fcaf05;
      }

      svg circle {
        fill: #fcaf05;
      }
    }

    &:first-of-type {
      svg {
        margin-right: 16px;
      }
    }

    &:last-of-type {
      margin-bottom: 0;
    }

    svg {
      margin-right: 18px;
    }

    p {
      margin: 0;
    }
  }
}
</style>
